import { ToastrModule } from 'ngx-toastr';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DesktopAlertComponent } from './desktop-alert/desktop-alert.component';



@NgModule({
  declarations: [
    DesktopAlertComponent
  ],
  imports: [
    CommonModule,
    ToastrModule
  ],
  exports: [
    DesktopAlertComponent
  ]
})
export class DesktopAlertModule { }
